import { CrudResource } from "@/components/CrudResource";
import { StatusBadge } from "@/components/StatusBadge";

const STATUS = [
  { value: "active", label: "status.active" },
  { value: "inactive", label: "status.inactive" },
  { value: "suspended", label: "status.suspended" },
];

export default function Clients() {
  return (
    <CrudResource
      title="menu.clients"
      subtitle="sub.clients"
      endpoint="/clients"
      testid="clients"
      searchPlaceholder="ph.clients"
      searchKeys={["name", "phone", "email", "country", "language", "status"]}
      columns={[
        { key: "name", label: "fld.name" },
        { key: "email", label: "auth.email" },
        { key: "phone", label: "auth.phone" },
        { key: "country", label: "fld.country" },
        { key: "language", label: "fld.language" },
        { key: "status", label: "common.status", render: (r) => <StatusBadge status={r.status || "active"} /> },
      ]}
      fields={[
        { name: "name", label: "fld.name", type: "text" },
        { name: "email", label: "auth.email", type: "text" },
        { name: "phone", label: "auth.phone", type: "text" },
        { name: "country", label: "fld.country", type: "text" },
        { name: "language", label: "fld.language", type: "text" },
        { name: "status", label: "common.status", type: "select", options: STATUS },
        { name: "discount", label: "fld.discount", type: "number" },
        { name: "address", label: "fld.address", type: "text" },
        { name: "notes", label: "fld.notes", type: "text" },
      ]}
      bulk={{
        statusOptions: STATUS,
        actions: [
          { key: "export", kind: "export", action: "export", label: "bulk.export", roles: ["admin", "support"] },
          { key: "status", kind: "status", label: "bulk.status", roles: ["admin", "support"] },
          { key: "discount", kind: "discount", action: "set_discount", label: "bulk.discount", roles: ["admin"] },
          { key: "delete", kind: "delete", action: "delete", label: "bulk.delete", roles: ["admin"] },
        ],
      }}
    />
  );
}
